import { React, useRef, useState } from "react";
import Offcanvas from "olive-react-myoneui/lib/Offcanvas";
import Nav from "olive-react-myoneui/lib/Nav";
import Tab from "olive-react-myoneui/lib/Tab";
import Button from "olive-react-myoneui/lib/Button";
import {
  documentIcon,
  downloadBaseIcon,
  exclamationIcon,
  lockPadDot,
  shareOIcon,
  uploadIcon,
  versionClockIcon,
} from "../../../constants/icons";

function DocDetailsOffcanvas({
  showDetailsOffcanvas,
  setShowDetailsOffcanvas,
  activeTabKey,
  setActiveTabKey,
  itemDetails,
  dmsConfig,
  handleDropdownClick,
  handleFileVersion,
}) {
  const fileVersionInputRef = useRef(null);

  const handleClose = () => setShowDetailsOffcanvas(false);
  const offCanvasKeyDown = (e) => e.stopPropagation();

  const handleClick = (action) => {
    let ditem = {};
    ditem.itemId = itemDetails.details.id;
    ditem.itemType = itemDetails.details.i_item_type;
    ditem.parentId = itemDetails.details.i_parent_id;
    ditem.itemName = itemDetails.details.i_item_name;
    ditem.itemOriginalFilename = itemDetails.details.i_orginal_filename;
    ditem.itemDocumentType = itemDetails.details.i_document_type;
    ditem.itemDocumentTags = itemDetails.details.i_document_tags;
    ditem.itemSectionType = itemDetails.details.i_section_id;
    ditem.itemFolderShortDescription = itemDetails.details.i_folder_short_desc;
    ditem.itemDownloadUrl = itemDetails.details.download_url;
    if (action === "Share") {
      ditem.key = "2";
      handleDropdownClick(ditem);
    } else if (action === "Download") {
      ditem.key = "3";
      handleDropdownClick(ditem);
    } else if (action === "Upload") {
      fileVersionInputRef.current.click();
    }
  };

  const accessRole = (strid, dele, share) => {
    var result = `-`;
    if (strid == "1") {
      result = `Editor`;
    } else if (strid == "2") {
      result = `Viewer`;
    } else {
      result = `-`;
    }
    if (result != "-") {
      if (share == "1" && dele == "1") {
        result += ` (Share,Delete)`;
      } else if (share == "1") {
        result += ` (Share)`;
      } else if (dele == "1") {
        result += ` (Delete)`;
      }
    }
    return result;
  };

  const handleFileChange = (e) => {
    let file = e.target.files[0];
    file.uploadUrl = itemDetails.upload_url;
    file.itemId = itemDetails.details.id;
    file.itemParentId = itemDetails.details.i_parent_id;
    handleFileVersion(file);
  };

  const handleDocumentVersionDownload = (downloadUrl) => {
    if (downloadUrl !== "") {
      window.open(downloadUrl, "_blank");
    }
  };

  return (
    <Offcanvas
      show={showDetailsOffcanvas}
      onHide={handleClose}
      placement="end"
      className="pb-0"
      onKeyDown={offCanvasKeyDown}
    >
      <Offcanvas.Header
        closeButton
        backButton="Back"
        className="pb-4 ps-4 messages-header myk__stu-doc_offcanvas-header"
      >
        <Offcanvas.Title>
          {itemDetails && itemDetails.details
            ? itemDetails.details.i_item_name
            : ""}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="pt-0 ps-4 pe-0 pb-0">
        <Tab.Container
          id="left-tabs-example"
          activeKey={activeTabKey}
          onSelect={(key) => setActiveTabKey(key)}
        >
          <Nav variant="pills">
            <Nav.Item>
              <Nav.Link eventKey="details">Details</Nav.Link>
            </Nav.Item>
            {itemDetails &&
            itemDetails.details &&
            itemDetails.details.i_item_type == 1 ? (
              <Nav.Item>
                <Nav.Link eventKey="version_history">Version History</Nav.Link>
              </Nav.Item>
            ) : (
              ""
            )}
          </Nav>
          <Tab.Content>
            <Tab.Pane className="myk__stu-doc-tabscontent" eventKey="details">
              <div className="myk__stu-doc-permissions">
                <h3>
                  {lockPadDot} <span>File Sharing Details</span>
                </h3>
                <div className="myk__stu-doc-owned_shared">
                  <table>
                    <tr>
                      {/* need to add svg icon before each name respectively */}
                      <th>Name</th>
                      <th>Permissions</th>
                    </tr>
                    {Object.keys(itemDetails).length > 0 &&
                      itemDetails.organisation.length > 0 &&
                      itemDetails.organisation.map((organisation) => (
                        <tr>
                          {dmsConfig.org_id == organisation.org_id &&
                          organisation.role_id != 0 ? (
                            <td>
                              {organisation.org_name} ({organisation.role_name})
                            </td>
                          ) : (
                            <td>{organisation.org_name}</td>
                          )}
                          <td>
                            {accessRole(
                              organisation.access_type,
                              organisation.delete_permission,
                              organisation.share_permission
                            )}
                          </td>
                        </tr>
                      ))}
                    {Object.keys(itemDetails).length > 0 &&
                      itemDetails.user_group.length > 0 &&
                      itemDetails.user_group.map((userGroup) => (
                        <tr>
                          <td>{userGroup.user_group_name}</td>
                          <td>
                            {accessRole(
                              userGroup.access_type,
                              userGroup.delete_permission,
                              userGroup.share_permission
                            )}
                          </td>
                        </tr>
                      ))}
                    {Object.keys(itemDetails).length > 0 &&
                      itemDetails.users.length > 0 &&
                      itemDetails.users.map((user) => (
                        <tr>
                          <td>{user.user_name}</td>
                          <td>
                            {accessRole(
                              user.access_type,
                              user.delete_permission,
                              user.share_permissions
                            )}
                          </td>
                        </tr>
                      ))}
                  </table>
                </div>
              </div>
              <div className="myk__stu-doc-file_details">
                <div className="myk__stu-doc_file-header">
                  <h4>
                    {exclamationIcon}{" "}
                    {itemDetails &&
                    itemDetails.details &&
                    itemDetails.details.i_item_type == 1 ? (
                      <span>File details</span>
                    ) : (
                      <span>Folder details</span>
                    )}
                  </h4>
                  <div className="myk__stu-file_header_actions">
                    {itemDetails.details.share_permission === "1" && (
                      <Button
                        variant="glitter"
                        type="button"
                        className="btn-grid-file btn-sm btn-round bg-white border-0"
                        onClick={() => handleClick("Share")}
                      >
                        {shareOIcon}
                      </Button>
                    )}
                    {itemDetails &&
                    itemDetails.details &&
                    itemDetails.details.i_item_type == 1 ? (
                      <Button
                        variant="glitter"
                        type="button"
                        className="btn-grid-file btn-sm btn-round bg-white border-0"
                        onClick={() => handleClick("Download")}
                      >
                        {downloadBaseIcon}
                      </Button>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="myk__stu-doc_file-details">
                  <ul>
                    {/* need to convert file size */}
                    {itemDetails &&
                    itemDetails.details &&
                    itemDetails.details.i_item_type == 1 ? (
                      <li>
                        <span>Size</span>
                        <h5>{itemDetails.details.i_file_size}</h5>
                      </li>
                    ) : (
                      ""
                    )}
                    {/* need to convert timezone */}
                    {itemDetails && itemDetails.details ? (
                      <li>
                        <span>Created on</span>
                        <h5>{itemDetails.details.created_date}</h5>
                      </li>
                    ) : (
                      ""
                    )}
                    {/* need to convert timezone */}
                    {itemDetails && itemDetails.details ? (
                      <li>
                        <span>Last Modified on</span>
                        <h5>{itemDetails.details.updated_date}</h5>
                      </li>
                    ) : (
                      ""
                    )}
                    {itemDetails &&
                    itemDetails.details &&
                    itemDetails.details.i_item_type == 1 &&
                    itemDetails.details.i_document_versions !== null ? (
                      <li>
                        <span>Version</span>
                        <h5>
                          v
                          {
                            JSON.parse(itemDetails.details.i_document_versions)[
                              JSON.parse(
                                itemDetails.details.i_document_versions
                              ).length - 1
                            ].version_id
                          }
                        </h5>
                      </li>
                    ) : (
                      ""
                    )}
                    {itemDetails &&
                    itemDetails.details &&
                    itemDetails.details.i_item_type == 1 ? (
                      <li>
                        <span>Tags</span>
                        <h5>{itemDetails.details.i_document_tags}</h5>
                      </li>
                    ) : (
                      ""
                    )}
                    {/* {itemDetails &&
                    itemDetails.details &&
                    itemDetails.details.i_item_type == 1 ? (
                      <li>
                        <span>Permissions</span>
                        <h5>{itemDetails.details.i_document_tags}</h5>
                      </li>
                    ) : (
                      ""
                    )} */}
                  </ul>
                </div>
              </div>
            </Tab.Pane>
            {itemDetails &&
            itemDetails.details &&
            itemDetails.details.i_item_type == 1 ? (
              <Tab.Pane
                className="myk__stu-doc-tabscontent"
                eventKey="version_history"
              >
                {itemDetails &&
                itemDetails.details &&
                itemDetails.details.i_document_versions !== null ? (
                  <div>
                    <div className="myk__stu-doc_file-header">
                      <h4>
                        {versionClockIcon} <span>Version History</span>
                      </h4>
                      {itemDetails.details.access_type === "1" ? (
                        <div className="myk__stu-file_header_actions">
                          <Button
                            variant="primary"
                            type="button"
                            className="btn-offcanvas-header btn-sm btn-round border-0"
                            onClick={() => handleClick("Upload")}
                          >
                            {uploadIcon} <span>Upload New Version</span>
                          </Button>

                          <input
                            type="file"
                            ref={fileVersionInputRef}
                            onChange={handleFileChange}
                            className="myk__stu-hidden"
                          ></input>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="myk__stu-doc_file-versions-list">
                      {JSON.parse(itemDetails.details.i_document_versions).map(
                        (version, index) => (
                          <div
                            key={index}
                            className="myk__stu-doc_version-item"
                          >
                            <div className="myk__stu-doc_version-content">
                              <div className="myk__stu-doc_version-icon">
                                {documentIcon}
                              </div>
                              <div className="myk__stu-doc_version-meta">
                                <h4>
                                  {version.original_name} ( v
                                  {version.version_id} ){" "}
                                  {version.active ? <span>Current</span> : ""}
                                </h4>
                                {/* need to convert this date */}
                                <p>{version.created_date}</p>
                              </div>
                            </div>
                            <Button
                              variant="glitter"
                              type="button"
                              className="btn-grid-file btn-sm btn-round bg-white border-0"
                              onClick={() =>
                                handleDocumentVersionDownload(
                                  version.download_url
                                )
                              }
                            >
                              {downloadBaseIcon}
                            </Button>
                          </div>
                        )
                      )}
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </Tab.Pane>
            ) : (
              ""
            )}
          </Tab.Content>
        </Tab.Container>
      </Offcanvas.Body>
      <Offcanvas.Footer>
        <Button variant="default" onClick={handleClose}>
          Close
        </Button>
      </Offcanvas.Footer>
    </Offcanvas>
  );
}

export default DocDetailsOffcanvas;
